
import React from 'react';
import MenuBar from '@/components/MenuBar';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';

const HowToUsePage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-6 pb-12">
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-foreground">{t('navigation.howToUse')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-foreground">
              Briefr er en nyhetsplattform som gir deg tilgang til kunnskapsbaserte artikler bygget på intervjuer med eksperter innen et bredt spekter av fagområder og temaer. Briefr er redaktørstyrt og driftes etter Vær Varsom-plakaten og Redaktørplakaten.
            </p>
            
            <h3 className="text-xl font-semibold mt-6">Innholdet i feeden</h3>
            <p className="text-foreground">
              I Briefr-feeden finner du artikler som består av dyptgående intervjuer med eksperter, fagfolk og ressurspersoner. Hvert intervju er bygget rundt ett enkelt, målrettet spørsmål som gir eksperten mulighet til å dele innsikt og kunnskap i dybden. Hver artikkel presenterer kunnskap og innsikt direkte fra kilden, formatert for å gi deg både oversikt og dybde i emnet.
            </p>
            <p className="text-foreground">
              Alle artikler er knyttet til en kontekst fra NTB (Norsk Telegrambyrå) som du kan lese ved å klikke på overskriften. Dette gir deg bakgrunnen for hvorfor spørsmålet er aktuelt og relevant akkurat nå.
            </p>
            
            <h3 className="text-xl font-semibold mt-6">Slik bruker du Briefr</h3>
            <ul className="list-disc pl-5 space-y-2 text-foreground">
              <li><strong>Les artikler:</strong> Bla gjennom feeden og klikk på artikler som interesserer deg for å lese hele intervjuet.</li>
              <li><strong>Utforsk med hashtags:</strong> Klikk på #hashtags for å finne alle artikler om samme tema eller emneområde.</li>
              <li><strong>Se flere perspektiver:</strong> For mange spørsmål vil du finne flere eksperters svar over tid – dette gir deg unike muligheter til å sammenligne perspektiver og se hvordan kunnskap utvikler seg.</li>
              <li><strong>Test din kunnskap:</strong> Ta quizen som følger hver artikkel for å sjekke hvor mye du husker og lærte.</li>
              <li><strong>Lytt til innholdet:</strong> Alle artikler kan leses opp for deg, perfekt når du er på farten eller foretrekker lytting fremfor lesing.</li>
              <li><strong>Chat med Kai:</strong> Vår AI-assistent Kai kan besvare spørsmål om artikkelen, gi deg dypere forklaringer, eller hjelpe deg med å forstå sammenhenger.</li>
              <li><strong>Utforsk relatert innhold:</strong> Bruk anbefalingene for å finne flere artikler om lignende temaer.</li>
            </ul>
            
            <h3 className="text-xl font-semibold mt-6">En levende kunnskapskilde</h3>
            <p className="text-foreground">
              Briefr samler svar fra ulike eksperter på de samme spørsmålene over tid. Dette gjør plattformen til en unik kunnskapskilde hvor du kan følge hvordan fagfolk med forskjellige perspektiver og bakgrunner besvarer de samme samfunnsaktuelle spørsmålene. Ved å sammenligne svarene får du et rikere og mer nyansert bilde av komplekse tema.
            </p>
            
            <h3 className="text-xl font-semibold mt-6">Møt Kai – din AI-assistent</h3>
            <p className="text-foreground">
              Kai er Briefrs AI-assistent som er tilgjengelig i hver artikkel. Kai kan hjelpe deg med å:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-foreground">
              <li>Forklare vanskelige begreper og konsepter fra artikkelen</li>
              <li>Gi deg ekstra kontekst og bakgrunnsinformasjon</li>
              <li>Svare på spørsmål relatert til intervjuets tema</li>
              <li>Hjelpe deg med å fordype deg i emnet</li>
            </ul>
            <p className="text-foreground mt-4">
              Kai er designet for å gjøre kunnskapen i artiklene mer tilgjengelig og gi deg mulighet til å utforske temaene på dine egne premisser.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default HowToUsePage;
